import Controller from '@ember/controller';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { dropTask } from 'ember-concurrency';
import { filter, mapBy } from 'macro-decorators';

export default class SettingsWelcomeScreenReturningVisitorsController extends Controller {
  @service flashMessages;
  @service featureFlags;
  @service featureConfig;

  // SQ-5694: exclude inactive/employee-related flows; SQ-5984: exclude property walkup flows
  @filter('model.flows', (f) => f.enabled && !(f.employeeCentric || f.isProtect || f.isWalkup)) enabledFlows;
  @mapBy('enabledFlows', 'signInFieldPage') signInFieldPagesPerFlow;

  get signInFieldsPerFlow() {
    return this.signInFieldPagesPerFlow.map((signInFieldPage) => get(signInFieldPage, 'signInFields'));
  }

  get hasEmailOrPhoneField() {
    return this.signInFieldsPerFlow.every((signInFields) => {
      // SQ-5694: handle unfulfilled Promise returns undefined instead of array
      if (!signInFields?.content) return true;

      return signInFields.content.some((field) => field.isEmailOrPhoneField);
    });
  }

  get hasIdScanEnabled() {
    const idScanEnabled = this.enabledFlows.any((flow) => get(flow, 'idScanPage.enabled'));
    return idScanEnabled && this.model.config.beenHereBefore;
  }

  get isBeenHereBeforeDisabled() {
    return this.toggleBeenHereBefore.isRunning || !this.hasEmailOrPhoneField;
  }

  get isFacialRecognitionEnabledDisabled() {
    return this.toggleFacialRecognitionEnabled.isRunning;
  }

  toggleBeenHereBefore = dropTask(async (value) => {
    const { config } = this.model;

    config.beenHereBefore = value;

    if (!value) {
      config.facialRecognitionEnabled = false;
    }

    try {
      await config.save();
      this.flashMessages.showAndHideFlash('success', 'Saved!');
    } catch (e) {
      config.rollbackAttributes();
      this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
    }
  });

  toggleFacialRecognitionEnabled = dropTask(async (value) => {
    const { config } = this.model;

    config.facialRecognitionEnabled = value;

    try {
      await config.save();

      if (value) {
        await Promise.all(
          this.enabledFlows.map(async (flow) => {
            const photoPage = await get(flow, 'photoPage');
            if (photoPage && !photoPage.enabled) {
              photoPage.enabled = true;
              await photoPage.save();
            }
          }),
        );
      }

      this.flashMessages.showAndHideFlash('success', 'Saved!');
    } catch (e) {
      config.rollbackAttributes();
      this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
    }
  });

  togglePassportEnabled = dropTask(async (value) => {
    const { config } = this.model;

    config.passportEnabled = value;

    try {
      await config.save();
      this.flashMessages.showAndHideFlash('success', 'Saved!');
    } catch (e) {
      config.rollbackAttributes();
      this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
    }
  });
}
